import { Grid, SxProps } from '@mui/material';
import React from 'react';
import { Filter, FilterType, OptionWithSelect } from '../FilterTypes';
import SearchComponent from '../SearchComponent';
import Filters from './Filters';
import { v4 as uuid } from 'uuid';
import SaveFilterDialog from '../SaveFilterDialog';
import { client } from '../../../utils/axios-client';
import { ApiResponseType } from '../../../types';
import { getUserLeadFiltersEndpoint, saveFilterEndpoint } from '../../../configs/endpoints';
import _ from 'lodash';
import { Option } from 'src/features/autocomplete/types';
import ShareFilterDialog from '../ShareFilterDialog';
import { FilterSingleLead, LeadScreenStore } from '../../../stores/LeadStore';
type Props = {
    onChange: (newFilter: Filter) => void;
    sx?: SxProps;
    filterType?: FilterType;
    height?: string;
};

const LeadSearch = ({ sx, onChange, filterType = FilterType.User, height = '100%' }: Props) => {
    const [saveFilterDialogOpen, setSaveFilterDialogOpen] = React.useState(false);
    const [saveMode, setSaveMode] = React.useState('save' as 'save' | 'saveAs');
    const [savedFilters, setSaveFilters] = React.useState([] as Option[]);
    const [shareFilterDialogOpen, setShareFilterDialogOpen] = React.useState(false);
    //const filterSingleLead = FilterSingleLead.useState(s => s.filterSingleLead);
    //const selectedLead = LeadScreenStore.useState(s => s.selectedLead);

    const [filter, setFilter] = React.useState({
        id: uuid(),
        description: '',
        searchTerm: '',
        options: [],
        activityDate: 'any',
        filterType: filterType,
        /* leadId: filterSingleLead ? selectedLead?.id : ''*/
    } as Filter);

    React.useEffect(() => {
        loadSavedFilters();
    }, []);

    React.useEffect(() => {
        const delayDebounceFn = setTimeout(() => {
            onChange(filter);
        }, 300);

        return () => clearTimeout(delayDebounceFn);
    }, [filter]);

    const loadSavedFilters = async () => {
        const response = await client.get(getUserLeadFiltersEndpoint, { params: { filterType: filterType } });
        setSaveFilters(response.data);
    };

    const onDescriptionChanged = (value: string) => {
        setFilter({ ...filter, description: value });
    };

    const onSearchTermChanged = (value: string) => {
        setFilter({ ...filter, searchTerm: value });
    };

    const onFiltersChanged = (updatedFilter: Filter) => {
        setFilter(updatedFilter);
        onChange(updatedFilter);
    };

    const onSave = () => {
        setSaveMode('save');
        setSaveFilterDialogOpen(true);
    };

    const onSaveAs = () => {
        setSaveMode('saveAs');
        setSaveFilterDialogOpen(true);
    };

    const onSaveFilterDialogClose = async (save: boolean) => {
        if (save) {
            const filterToSave = _.cloneDeep(filter);

            if (saveMode === 'saveAs') {
                filterToSave.id = uuid();
                filterToSave.options.forEach((opt) => {
                    opt.id = uuid();
                });
            }

            const response = await client.post<ApiResponseType>(saveFilterEndpoint, filterToSave);

            if (response.data.succeeded) {
                loadSavedFilters();
                setSaveFilterDialogOpen(false);
                setFilter(filterToSave);
            } else {
            }
        }

        setSaveFilterDialogOpen(false);
    };

    const onClearFilter = () => {
        setFilter({
            id: uuid(),
            description: '',
            searchTerm: '',
            options: [],
            activityDate: 'any',
            filterType: FilterType.User,
        } as Filter);

        onChange({} as Filter);
    };

    const onShareFilter = () => {
        setShareFilterDialogOpen(true);
    };

    return (
        <>
            <Grid container height={height}>
                <Grid item xs={12} height={height}>
                    <SearchComponent
                        searchTerm={filter.searchTerm}
                        onSearchTermChanged={onSearchTermChanged}
                        sx={sx}
                        onSave={onSave}
                        onSaveAs={onSaveAs}
                        onClearFilter={onClearFilter}
                        onShareFilter={onShareFilter}
                        onFiltersChanged={onFiltersChanged}
                        savedFilterId={filter.id}
                        savedFilters={savedFilters}
                    >
                        <Filters onFiltersChanged={onFiltersChanged} filter={filter} />
                    </SearchComponent>
                </Grid>
            </Grid>
            <SaveFilterDialog
                open={saveFilterDialogOpen}
                value={filter.description}
                title={saveMode === 'save' ? 'Save' : 'Save As'}
                onClose={onSaveFilterDialogClose}
                onChange={onDescriptionChanged}
            />
            <ShareFilterDialog
                open={shareFilterDialogOpen}
                onClose={() => setShareFilterDialogOpen(false)}
                filter={filter}
            />
        </>
    );
};

export { LeadSearch };
export default LeadSearch;
